import format, { TFormatProps } from '@r1-frontend/ui-react/components/costs/Cost/format';

export interface IBaseCostProps {
    children: string | number,
    isPreviously?: boolean,
    className?: string,
}

export interface IMonthlyCostProps extends IBaseCostProps {
    isMonthly?: boolean,
    isAnnually?: never,
}

export interface IAnnuallyCostProps extends IBaseCostProps {
    isMonthly?: never,
    isAnnually?: boolean,
}

export type TCostProps = IMonthlyCostProps | IAnnuallyCostProps;

const Cost = ({
    children,

    ...props
}: TCostProps) => {
    const options: TFormatProps | undefined = props.isMonthly
        ? { monthly: true }
        : props.isAnnually
            ? { annually: true }
            : undefined;

    return (
        <span {...props}>
            {format(children, options)}
        </span>
    );
};

export default Cost;
